import { Component, Input, OnInit, OnChanges } from '@angular/core';

@Component({
  selector: 'ingo-initials-avatar',
  styleUrls: ['./initials-avatar.component.scss'],
  template: `{{ intials }}`
})
export class InitialsAvatarComponent implements OnChanges, OnInit {

  @Input() firstName: string = '';
  @Input() lastName: string = '';

  intials: string;

  ngOnInit() {
    this.setInitials();
  }

  ngOnChanges() {
    this.setInitials();
  }

  setInitials() {
    const intials = this.firstName.charAt(0) + this.lastName.charAt(0);
    this.intials = intials.toUpperCase();
  }
}
